'use client'

import { useProductSelection } from '@/contexts/ProductSelectionContext'
import { FaTimes, FaInfoCircle } from 'react-icons/fa'
import Button from '@/components/ui/Button'

export default function FirstProductPopup() {
  const { showFirstProductPopup, dismissFirstProductPopup } = useProductSelection()

  if (!showFirstProductPopup) return null

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={dismissFirstProductPopup}
      />
      
      {/* Popup */}
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
        <button
          onClick={dismissFirstProductPopup}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
          aria-label="Kapat"
        >
          <FaTimes className="text-gray-500" />
        </button>
        
        <div className="flex items-start gap-4 mb-4">
          <div className="p-3 bg-primary-100 rounded-xl flex-shrink-0">
            <FaInfoCircle className="text-2xl text-primary-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Ürün Eklendi!
            </h3>
            <p className="text-gray-700 leading-relaxed">
              İlgilendiğiniz ürünleri ekleyip, sağ üst köşedeki <strong>"Bilgi Al"</strong> düğmesine basarak, bizimle iletişime geçebilirsiniz.
            </p>
          </div>
        </div>
        
        <Button
          onClick={dismissFirstProductPopup}
          className="w-full"
        >
          Anladım
        </Button>
      </div>
    </div>
  )
}

